import { useState, useEffect, useMemo, useRef, useContext } from "react";
import { useSession } from "next-auth/react";
import {
  Text,
  Button,
  Center,
  Box,
  useColorModeValue,
} from "@chakra-ui/react";
import { addRemovePeopleToList, enrich, getContacts } from "controllers/list";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { MainContext } from "../../context/mainContext";
import { textStyle } from "theme/names";


export const GetEmailButton = ({ session, contacts, setContacts = undefined as any, data, row, value, columnRefresher }) => {

  // const [isLoading, setIsLoading] = useState<boolean>(!!row.isLoadingEmail);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [email, setEmail] = useState(value?.length ? value[0] : undefined);
  const mainContext = useContext(MainContext);

  // console.log("render GetEmailButton isLoading: " + isLoading);

  return (
    <Box textAlign="left">
      {
        email ? email !== "Not found" ? (
          <CopyToClipboard
            text={email}
            onCopy={() => {
              toast.success("Email copied to clipboard");
            }}
          >
            <Text textStyle={textStyle["body.bold.light"]}
              noOfLines={1} wordBreak={"break-all"}
              mr="2"
              // fontSize="sm"
              // fontWeight="600"
              cursor="pointer"
              onClick={e => e.stopPropagation()}
            >
              {email}
            </Text>
          </CopyToClipboard>
        ) : (
          <Text textStyle={textStyle["body.bold.light"]}
            noOfLines={1} wordBreak={"break-all"}
            mr="2"
            // fontSize="sm"
            // fontWeight="600"
            cursor="auto"
          >
            {email}
          </Text>
        ) : (
          <Button
            size="sm"
            variant="secondary"
            // _hover={{
            //   background: useColorModeValue("gray.200", "whiteAlpha.200"),
            // }}
            isLoading={isLoading}
            onClick={async (e) => {
              e.stopPropagation();
              // console.log({ row });
              // console.log({ value });
              setIsLoading(true);
              row.isLoadingEmail = true;
              // row.emails = ["toto"];
              await enrich(
                session,
                [row.original],
                contacts,
                undefined,
                data,
                [setEmail],
                mainContext,
                true,
                columnRefresher
              );
              setIsLoading(false);
              row.isLoadingEmail = false;
              // console.log("end");
            }}
          >
            Get Email
          </Button>
        )
      }
    </Box>
  );
}